function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M472,0H264c-4.418,0-8,3.582-8,8v120c0,4.418,3.582,8,8,8s8-3.582,8-8V16h192v448H8c-4.418,0-8,3.582-8,8s3.582,8,8,8h464 c4.418,0,8-3.582,8-8V8C480,3.582,476.418,0,472,0z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M219.536,299.736l53.072-26.936c13.736-7.074,19.282-23.843,12.472-37.712c-3.287-6.717-9.141-11.826-16.24-14.176 c-7.012-2.345-14.674-1.768-21.256,1.6l-30.4,15.4l-10.336-17.432c29.437-7.032,47.599-36.597,40.567-66.034 s-36.597-47.599-66.034-40.567s-47.599,36.597-40.567,66.034c0.579,2.423,1.323,4.805,2.225,7.127L77.6,214.688 c-8.505,3.329-14.857,10.591-17.024,19.464l-13.272,53.76c-3.725,15.004,5.313,30.212,20.272,34.112 c7.137,1.839,14.714,0.729,21.024-3.08c6.45-3.851,11.083-10.132,12.856-17.432l9.744-39.664l19.016-7.888l-10.28,57.28 l-40.52,45.408L46.312,327.32c-11.445-10.174-28.972-9.143-39.146,2.302c-0.102,0.114-0.203,0.23-0.302,0.346 C-3.179,341.697-2.01,359.302,9.496,369.6l53.064,47.04c11.158,9.476,27.69,8.918,38.184-1.288l50.904-51.56l40.656,24.696 l29.544,59.88c4.645,9.567,14.349,15.639,24.984,15.632c4.349,0.005,8.638-1.023,12.512-3 c13.741-7.074,19.285-23.851,12.464-37.72l-33.176-67.2c-2.356-4.78-6.024-8.79-10.576-11.56l-49.16-29.88l5.256-23.936 C192.019,302.153,207.144,306.014,219.536,299.736z M180.152,259.192c-3.375,0.411-6.122,2.911-6.848,6.232L162.048,316.8 c-0.73,3.336,0.738,6.768,3.656,8.544l54.048,32.848c1.95,1.199,3.523,2.923,4.536,4.976l33.168,67.2 c2.965,5.997,0.595,13.264-5.336,16.36h0c-5.898,2.842-12.985,0.432-15.928-5.416L205.6,379.36 c-0.669-1.365-1.716-2.508-3.016-3.296l-48.048-29.208c-3.17-1.923-7.246-1.417-9.848,1.224l-55.352,56.072 c-4.439,4.345-11.459,4.584-16.184,0.552l-53.064-47.04c-5.001-4.484-5.502-12.142-1.128-17.24 c4.206-4.926,11.608-5.51,16.534-1.305c0.065,0.056,0.13,0.112,0.194,0.169l39.064,34.616c3.297,2.922,8.336,2.629,11.272-0.656 l47.344-53.04c0.984-1.103,1.643-2.457,1.904-3.912l13.264-73.92c0.764-4.352-2.145-8.499-6.497-9.262 c-1.496-0.263-3.036-0.094-4.439,0.486l-36.272,15.048c-2.35,0.975-4.097,3.009-4.704,5.48L85.88,297.68 c-0.756,3.154-2.752,5.871-5.536,7.536c-2.654,1.617-5.851,2.085-8.856,1.296c-6.456-1.707-10.331-8.296-8.688-14.768 l13.272-53.776c0.963-3.878,3.763-7.039,7.496-8.464l63.696-26.88l9.768,4.232c4.062,1.738,8.764-0.146,10.502-4.208 c1.244-2.907,0.658-6.275-1.494-8.592c-6.9-7.292-10.74-16.953-10.728-26.992c0.327-21.232,17.804-38.178,39.035-37.851 s38.178,17.804,37.851,39.035c-0.323,21.002-17.442,37.858-38.447,37.856c-4.418-0.004-8.003,3.575-8.007,7.993 c-0.001,1.438,0.385,2.85,1.119,4.087l19.912,33.6c1.567,2.614,4.473,4.121,7.512,3.896l2.264-0.176 c1.04-0.085,2.053-0.37,2.984-0.84l35.272-17.864c2.777-1.432,6.018-1.672,8.976-0.664c3.031,1.011,5.529,3.195,6.936,6.064 c2.984,6.005,0.607,13.293-5.344,16.384l-53.072,26.888c-5.909,2.823-12.99,0.388-15.912-5.472l-8.104-16.408 C186.816,260.517,183.531,258.74,180.152,259.192z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M421.656,242.344l-32-32c-3.178-3.07-8.242-2.982-11.312,0.196c-2.994,3.1-2.994,8.015,0,11.116L396.688,240H312 c-4.418,0-8,3.582-8,8s3.582,8,8,8h84.688l-18.344,18.344c-3.178,3.07-3.266,8.134-0.196,11.312 c3.07,3.178,8.134,3.266,11.312,0.196c0.066-0.064,0.132-0.13,0.196-0.196l32-32C424.779,250.532,424.779,245.468,421.656,242.344 z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M264,296c-4.418,0-8,3.582-8,8v56c0,4.418,3.582,8,8,8s8-3.582,8-8v-56C272,299.582,268.418,296,264,296z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M264,184c-4.418,0-8,3.582-8,8v8c0,4.418,3.582,8,8,8s8-3.582,8-8v-8C272,187.582,268.418,184,264,184z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var SvgNavMenuLogoutIcon = function SvgNavMenuLogoutIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNavMenuLogoutIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav-menu-logout-icon.173ecb00.svg";
export { ForwardRef as ReactComponent };